import React from 'react';

const STATS = [
  { num: '365', lbl: 'Days/Year Yield' },
  { num: '70%', lbl: 'Less Water Use' },
  { num: '3×',  lbl: 'Higher Yields'  },
  { num: 'Zero',lbl: 'Climate Risk'   },
];

export default function Hero() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="min-h-screen flex items-center relative overflow-hidden pt-[70px]">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f0d] via-[#1a3d1e] to-[#0d2b10]" />
      {/* Dot pattern */}
      <div className="absolute inset-0 opacity-[0.06]"
        style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,.8) 1px, transparent 0)', backgroundSize: '32px 32px' }}
      />
      {/* Glow */}
      <div className="absolute top-1/4 right-[10%] w-[500px] h-[500px] rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(74,222,128,.12) 0%, transparent 70%)' }}
      />

      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10 w-full py-16">
        {/* Text */}
        <div>
          <div className="inline-flex items-center gap-2 bg-green-400/10 border border-green-400/25 rounded-full px-4 py-2 text-xs font-medium text-green-300 tracking-widest mb-6">
            <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse-dot" />
            Sustainable · Modern · Quality
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Growing Quality,<br />
            <em className="text-green-300 not-italic font-serif">Sustaining</em> the Future
          </h1>

          <p className="text-green-200/80 text-lg leading-relaxed mb-10 font-light">
            Global Exclusive Ariel Farm Ltd — a professionally managed agricultural enterprise committed to sustainable food production, modern greenhouse farming, and long-term value creation.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo('#about')}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold text-base px-7 py-3.5 rounded-xl transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-green-600/30"
            >
              Discover Our Farm
            </button>
            {/* <button
              onClick={() => scrollTo('#greenhouse')}
              className="border border-white/30 hover:border-white/60 text-white font-medium text-base px-7 py-3.5 rounded-xl transition-all duration-200 hover:bg-white/5"
            >
              Greenhouse Tech →
            </button> */}
          </div>
        </div>

        {/* Visual card */}
        <div className="hidden lg:block">
          <div className="bg-white/6 border border-white/12 rounded-2xl p-8 backdrop-blur-sm">
            <GreenhouseSVG />
            <div className="grid grid-cols-4 gap-3 mt-6">
              {STATS.map(s => (
                <div key={s.lbl} className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
                  <span className="block font-serif text-2xl font-bold text-green-300">{s.num}</span>
                  <span className="text-green-600 text-xs mt-0.5 tracking-wide">{s.lbl}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function GreenhouseSVG() {
  return (
    <svg className="w-full" viewBox="0 0 400 280" xmlns="http://www.w3.org/2000/svg">
      <rect width="400" height="280" fill="#0a1f0d"/>
      <rect y="220" width="400" height="60" fill="#1a3d1e"/>
      <polygon points="200,40 60,140 340,140" fill="#1e4d24" stroke="#4ade80" strokeWidth="1.5"/>
      <rect x="60" y="140" width="280" height="80" fill="#1e4d24" stroke="#4ade80" strokeWidth="1.5"/>
      <polygon points="200,50 80,140 200,140" fill="rgba(74,222,128,0.06)" stroke="rgba(74,222,128,0.2)" strokeWidth="1"/>
      <polygon points="200,50 320,140 200,140" fill="rgba(74,222,128,0.06)" stroke="rgba(74,222,128,0.2)" strokeWidth="1"/>
      <line x1="140" y1="95" x2="140" y2="140" stroke="rgba(74,222,128,0.15)" strokeWidth="1"/>
      <line x1="170" y1="62" x2="170" y2="140" stroke="rgba(74,222,128,0.15)" strokeWidth="1"/>
      <line x1="230" y1="62" x2="230" y2="140" stroke="rgba(74,222,128,0.15)" strokeWidth="1"/>
      <line x1="260" y1="95" x2="260" y2="140" stroke="rgba(74,222,128,0.15)" strokeWidth="1"/>
      <rect x="178" y="170" width="44" height="50" rx="3" fill="rgba(74,222,128,0.08)" stroke="rgba(74,222,128,0.3)" strokeWidth="1"/>
      <circle cx="200" cy="196" r="2" fill="#4ade80"/>
      <g opacity=".8">
        <ellipse cx="100" cy="195" rx="18" ry="10" fill="#166534"/>
        <rect x="99" y="190" width="2" height="25" fill="#14532d"/>
        <ellipse cx="130" cy="188" rx="14" ry="8" fill="#15803d"/>
        <rect x="129" y="184" width="2" height="28" fill="#14532d"/>
        <ellipse cx="270" cy="190" rx="16" ry="9" fill="#15803d"/>
        <rect x="269" y="186" width="2" height="28" fill="#14532d"/>
        <ellipse cx="300" cy="195" rx="18" ry="10" fill="#166534"/>
        <rect x="299" y="190" width="2" height="25" fill="#14532d"/>
      </g>
      <circle cx="340" cy="60" r="20" fill="rgba(201,168,76,0.15)"/>
      <circle cx="340" cy="60" r="12" fill="rgba(201,168,76,0.25)"/>
      <circle cx="340" cy="60" r="6" fill="rgba(201,168,76,0.5)"/>
      <g fill="rgba(255,255,255,0.4)">
        <circle cx="30" cy="30" r="1.5"/><circle cx="70" cy="20" r="1"/>
        <circle cx="120" cy="15" r="1.5"/><circle cx="280" cy="20" r="1"/>
        <circle cx="360" cy="35" r="1.5"/><circle cx="380" cy="15" r="1"/>
      </g>
      <text x="200" y="252" textAnchor="middle" fill="#4ade80" fontSize="10" fontFamily="DM Sans,sans-serif" fontWeight="500" opacity=".7">
        Modern Greenhouse Farming System
      </text>
    </svg>
  );
}
